import React from 'react';

export default function BackBtn({ onClick }) {
  return (
    <button
      onClick={onClick}
      style={{
        background: 'none',
        border: '1px solid var(--border)',
        borderRadius: 6,
        color: 'var(--muted)',
        cursor: 'pointer',
        padding: '4px 10px',
        fontSize: 13,
        flexShrink: 0,
      }}
    >
      ← Back
    </button>
  );
}
